export default __webpack_public_path__ + "static/media/Skull Gate Pauldrons.f18ff733.jpg";